// Per-tenant, per-mode logo assets bundled under public/images/. The Shopping
// API's branding-image contract only exposes a single (light) Logo, so — as in
// Luci.Shopping.UI — the invoice portal ships its own dark-mode logo variants as
// static assets and selects the right one for the active theme mode.
const AndroidChrome = '/android-chrome-384x384.png';
const PaparazziPremiereWhiteLogo =
  '/images/tenant-4/branding/logo-horizontal-dark-lg.webp';
const PaparazziPremiereBlackLogo =
  '/images/tenant-4/branding/logo-horizontal-light-xl.webp';
const SmallPaparazziPremiereLogo =
  '/images/tenant-4/branding/logo-vertical-light-sm.webp';
const JordanEssentialsDarkLogo =
  '/images/tenant-5/branding/logo-horizontal-dark-xl.webp';
const JordanEssentialsLightLogo =
  '/images/tenant-5/branding/logo-horizontal-light-lg.webp';
const JordanEssentialsVerticalLogo =
  '/images/tenant-5/branding/logo-vertical-light-xl.webp';
const WayrooDarkLogo = '/images/wayroo/branding/logo-horizontal-dark-xl.webp';
const WayrooLightLogo = '/images/wayroo/branding/logo-horizontal-light-lg.webp';

const PAPARAZZI_LOGOS = {
  light: {
    full: PaparazziPremiereBlackLogo,
    small: SmallPaparazziPremiereLogo,
  },
  dark: {
    full: PaparazziPremiereWhiteLogo,
    small: SmallPaparazziPremiereLogo,
  },
};

const DEFAULT_LOGOS = {
  light: {
    full: WayrooLightLogo,
    small: AndroidChrome,
  },
  dark: {
    full: WayrooDarkLogo,
    small: AndroidChrome,
  },
};

const JORDAN_ESSENTIALS_LOGOS = {
  light: {
    full: JordanEssentialsLightLogo,
    small: JordanEssentialsVerticalLogo,
  },
  dark: {
    full: JordanEssentialsDarkLogo,
    small: JordanEssentialsVerticalLogo,
  },
};

type LogoSet = { full: string; small: string };

export const getTenantLogos = (
  tenantId?: number,
  themeMode: 'light' | 'dark' = 'light'
): LogoSet => {
  const logos = (() => {
    switch (tenantId) {
      case 4: // Paparazzi
        return PAPARAZZI_LOGOS;
      case 5: // Jordan Essentials
        return JORDAN_ESSENTIALS_LOGOS;
      default: // Wayroo
        return DEFAULT_LOGOS;
    }
  })();

  return logos[themeMode] || logos.light;
};

export default getTenantLogos;
